/* eslint-disable */
// tslint:disable
export const DEFAULT_MESSAGE: { [id: string]: string } = {
    'account.id': 'Username',
    'address.billing': 'Billing Address',
    'address.billing.choose': 'Choose a billing address',
    'address.billing_for_card': 'This is the billing address for your card',
    'address.delete_confirmation.warning_top': 'You are about to delete your address.',
    'address.delete_confirmation.warning_top_default':
        'You are about to delete your default address.',
    'address.delete': 'Delete address',
    'address.edit': 'Edit address and contact information',
    'address.make_default': 'Shipping address',
    'address.set_overseas': 'Overseas',
    'address.postalcode.search': 'Postal code search (Japan only)',
    'address.list.phone_number': 'Telephone:',
    'address.list.mobile_number': 'Mobile phone:',
    'address.new': 'Add address',
    'address.new_billing': '+ Add new address',
    'address.new_limit_reached': 'Address registration limit reached ',
    'address.updated_info_box.title':
        'Updates to your information will not be reflected in the following Rakuten services. Please update your information for each separately.',
    'address.updated_info_box.description':
        'Redirects to the information update page for each Rakuten service.',
    'password.info':
        'Your password must be at least eight characters long and include at least one uppercase letter, one lowercase letter, one digit, and one special character.',
    'password.score': 'Strength: ',
    'password.score.weak': 'Weak',
    'password.score.medium': 'Medium',
    'password.score.strong': 'Strong',
    'agreement.cp': 'Cookie Policy',
    'agreement.pp': 'Privacy Policy',
    'agreement.tc': 'Terms and Conditions',
    'agreement.text': 'You agree to the {tc} and acknowledge to have read the {pp} and {cp}.',
    'am.category.entertainment': 'Entertainment',
    'am.category.electricals': 'Electricals',
    'am.category.fashion': 'Fashion & Accessories',
    'am.category.department': 'Department Stores',
    'am.category.home-garden': 'Home & Garden',
    'am.category.footwear': 'Footwear',
    'am.category.toys': 'Toys',
    'am.category.gaming': 'Gaming',
    'am.category.jewellery': 'Jewellery',
    'am.category.leisure': 'Leisure',
    'am.category.sports-outdoors': 'Sports & Outdoors',
    'am.category.health-beauty': 'Health & Beauty',
    'am.category.telecoms': 'Telecoms',
    'am.category.gifts': 'Gifts',
    'am.category.travel': 'Travel',
    'am.category.finance': 'Finance & Utilities',
    'am.category.electronica': 'Electronics & Video games',
    'am.category.moda': 'Fashion',
    'am.category.deporte': 'Sports',
    'am.category.hogar': 'Home',
    'am.category.gourmet': 'Gourmet',
    'am.category.optica': 'Eyewear',
    'am.sidemenu.top': '{email} | Points held: {points} ',
    'am.sidemenu.myPoints': 'My Points',
    'am.sidemenu.myAccount': 'My Account',
    'am.sidemenu.redeem': 'Redeem Your Points',
    'am.sidemenu.rewards': 'Our Rewards',
    'am.sidemenu.rsp': 'Rakuten Point',
    'am.sidemenu.rtv': 'About Rakuten TV',
    'am.sidemenu.viber': 'About Rakuten Viber',
    'am.sidemenu.kobo': 'About Rakuten Kobo',
    'am.sidemenu.fcb': 'FC Barcelona',
    'am.sidemenu.faqs': 'FAQs',
    'app.choose_rak_id': 'Choose a username',
    'app.greeting': 'Hello, {memberName}',
    'app.label_points': 'Points held:',
    'app.logout': 'Sign Out',
    'app.logout.confirm': 'Are you sure you want to sign out?',
    'app.points': 'Rakuten Point',
    'app.transaction_earned': 'Points earned:',
    'app.transaction_spent': 'Points used:',
    'app.update_email': 'Update my email',
    'app.update_pass': 'Update my password',
    'app.update_rak_id': 'Update my username',
    'button.add': 'Add',
    'button.back': 'back',
    'button.back_to_known': 'Bring me to a known place',
    'button.back_to_site': 'Back to {site}',
    'button.cancel': 'Cancel',
    'button.keepMembership': 'Keep Membership',
    'button.close': 'Close',
    'button.change': 'Change',
    'button.delete': 'Delete',
    'button.delete_account': 'Delete account',
    'button.edit': 'Edit',
    'button.save': 'Save changes',
    'button.signin': 'Sign in',
    'button.success': 'Success',
    'button.send_veri_code': 'Send verification code',
    'button.scanCard': 'Scan Card',
    'button.delete_cancel_membership': 'Cancel membership',
    'button.unlink': 'Unlink',
    copyright: '© Rakuten Group, Inc.',
    customer_support: 'customer support',
    'dob.disabled_notification':
        'Your date of birth can only be set once. If you need to modify it, please contact {cs}.',
    'dob.disabled_notification_no_csurl': 'Your date of birth can only be set once.',
    'dsr.info': 'Info',
    'dsr.delete_link_message': 'Delete my account for this service',
    'dsr.delete_request_again': 'Request again',
    'dsr.account_deletion': 'Account deletion',
    'dsr.account_deletion_requested': 'Requested on',
    'dsr.account_deletion_pending': 'Account deletion requested successfully',
    'dsr.account_deletion_failed': 'Operation not possible',
    'dsr.delete_service_confirmation_heading': 'Before you continue',
    'dsr.delete_service_confirmation_body_1':
        'Account deletion will completely delete your data from the service, including any purchases, navigation history and personal information exclusive to the service.',
    'dsr.delete_service_confirmation_body_2':
        'After the operation is complete, you will no longer have access to that service. If your Rakuten account is not connected to any other service, your credentials will be permanently deleted too (you can create a new account later).',
    'dsr.delete_service_confirmation_body_3':
        'Please take into account that deletion of your data from the service can take up to 30 days. ',
    'dsr.delete_service_confirmation_body_4': 'Are you sure you want to delete your account? ',
    'dsr.delete_service_confirmation_confirm': 'Confirm',
    'error.email_not_found': 'Email not found',
    'error.address_line_required':
        'Please enter your address (street, building number, floor, etc.)',
    'error.billing_address_required': "Please enter the card's billing address",
    'error.common.unsupported_char': '{field} contains invalid characters',
    'error.common.include_full_width_space': 'Full-width spaces are not allowed',
    'error.captcha': 'Captcha text does not match',
    'error.card_holder_name_invalid':
        'The following characters are not allowed: < > & " ? / # % ^ * ( ) \\ |',
    'error.card_holder_name_invalid_jp_ap':
        'Contains invalid characters (e.g., Chinese characters, é, ö, û, etc.).',
    'error.card_holder_name_invalid_symbols':
        'Contains invalid symbols (< > & " ? # % ^ *   / { } ( | ).',
    'error.card_holder_name_contains_numbers':
        "Invalid character(s) found in the cardholder's name. Please enter the name as printed on the card.",
    'error.card_holder_name_required': 'Please enter your name as shown on the card',
    'error.card_holder_name_required_jp_ap': 'Please enter the name as shown on the card.',
    'error.card_holder_name_no_credit_card': 'Do not include your card number.',
    'error.invalid_length_too_small': 'Please enter at least {min} characters.',
    'error.invalid_length_too_large': 'Please enter up to {max} characters.',
    'hint.card_holder_name_contains_numbers_or_symbols':
        'Hint: Contains numbers or unexpected symbols. Please ignore this hint if the cardholder name printed on your card contains these numbers or unexpected symbols.',
    'notification.cardholder_name.title': '[Notification] Please Check Your Cardholder Name',
    'notification.cardholder_name.line1':
        'To ensure smooth 3D Secure credit card payments on Rakuten services, please confirm that the cardholder name you have registered under "{paymentMethod}" exactly matches the name printed on your card.',
    'notification.cardholder_name.line2':
        'If your cardholder name is registered using non-Latin characters (e.g. Chinese characters, etc.), some card issuers may treat it as an invalid format or a mismatch. In such cases, 3D Secure authentication may not succeed and the payment might fail.',
    'notification.cardholder_name.line3':
        'You can review your currently registered card information from the "{paymentMethod}" page. To modify your card information, please press the "pencil" icon on the relevant card entry.',
    'payment.notice.paragraph1':
        'To prevent payment issues, please only register credit cards that are issued in your own name.',
    'payment.notice.paragraph2':
        'Please ensure that the registered cardholder name exactly matches the name printed on the card and that it is registered in Latin characters. Chinese characters, etc., are not allowed.',
    'payment.card_sharing.disclaimer.line1':
        'Due to data protection regulations, only cards eligible for use with {serviceName} are being displayed.',
    'payment.card_sharing.disclaimer.line2':
        "A card is eligible for use if you have given consent to the storage and sharing of the card's information with {serviceName} on or after {migrationDate}, or if the card was saved to your account before {migrationDate} and you have previously used {serviceName}.",
    'error.card_number_invalid': 'Please enter a valid card number',
    'error.card_number_length':
        'Please enter your card number. It must be between 12 and 19 digits (usually 16).',
    'error.card_number_required': 'Please enter your card number',
    'error.city_required': 'Please enter your municipality (city, ward, town, village)',
    'error.city_select_required': 'Please select your municipality (city, ward, town, village)',
    'error.country_required': 'Please enter your Country',
    'error.current_password_missing': 'Please enter your current password',
    'error.dob_adult': 'You must be at least 18 years old to create a username',
    'error.dob_invalid': 'Please enter a valid date of birth',
    'error.dob_update': 'You should be over 18 years of age to use the Rakuten services',
    'error.email.digits': 'The domain of the email address cannot contain digits',
    'error.email.invalid': 'Please enter a valid email',
    'error.email.long': 'Email must be less than {n} characters long',
    'error.email.short': 'Email address must be more than {n} characters long',
    'error.email.registered': 'This email already exists',
    'error.email.required': 'Email is mandatory',
    'error.email.unknown': 'Email not found. Please register a Rakuten account. ',
    'error.email.username_boundaries':
        'Username or email must be more than 8 and less than 128 characters long',
    'error.fax_number.required': 'Please enter your fax number',
    'error.fax_number.invalid': 'Please enter a valid fax number',
    'error.fax_number.invalid_jp': 'Please enter a valid fax number',
    'error.email.username_invalid': 'Email or username is invalid',
    'error.email.username_required': 'Email or username is required',
    'error.encoding': 'This field cannot contain non-latin characters',
    'error.expiry_required': 'Please enter expiration date as shown on the card',
    'error.first_name_kana_validated': 'Please enter your first name in full-width katakana.',
    'error.last_name_kana_validated': 'Please enter your last name in full-width katakana.',
    'error.field_invalid': 'Please enter a valid {fieldName}',
    'error.field_required': '{fieldName} is mandatory',
    'error.banchi_required':
        'Street address must have a block number. If this address doesn’t have a block number, please click the link below. ',
    'error.banchi_warning':
        'There may be an issue with this address. Please make sure the address is entered correctly.',
    'error.first_name_required': 'Please enter your first name',
    'error.mobile_email_address_invalid': 'Please enter a valid mobile email',
    'error.first_name_kana_required': 'Please enter your first name (kana)',
    'error.generic': 'Sorry, something went wrong. Please try again later.',
    'error.illegal_chars': `Cannot contain spaces or special characters (ñ、¿、Å etc.).`,
    'error.last_name_required': 'Please enter your last name',
    'error.last_name_kana_required': 'Please enter your last name (kana)',
    'error.long_field': 'This field cannot contain more than 255 characters',
    'error.long_field_n': 'This field cannot contain more than {n} characters',
    'error.new_email_missing': 'Please enter your new email',
    'error.new_email.no_current_email': 'The new email cannot be the same as your current email',
    'error.new_password.no_email':
        'The new password cannot be the same as your current email or username',
    'error.new_password.no_old': 'The new password cannot be the same as your current one',
    'error.password.incorrect': 'Password is incorrect',
    'error.password.mismatch':
        'Passwords do not match. Please enter the same password in both fields.',
    'error.password.no_lower': 'Must contain at least one lowercase letter (a-z).',
    'error.password.missing': 'Please enter your password',
    'error.password.outside_boundaries': 'Please enter at least {min} characters.',
    'error.password.no_capital': 'Must contain at least one uppercase letter (A-Z).',
    'error.password.no_digit': 'Must contain at least one number (0-9).',
    'error.password.no_special':
        'Must contain at least one symbol ( ~ ! @ # $ % ^ & * ( ) _ + \u007D \u007B < > [ ] \\ ? , " ; \' , . / = -).',
    'error.password.no_special_jp':
        'Must contain at least one symbol ( ~ ! @ # $ % ^ & * ( ) _ + \u007D \u007B [ ] \\ ? , " ; \' , . / = -).',
    'error.password.repeat': 'Please enter your new password again',
    'error.password.repeat_missing': 'Please enter your new password again',
    'error.password.required': 'Password is mandatory',
    'error.payvault.invalid_details':
        'There was a problem processing your card. Please try a different card.',
    'error.payvault.unavailable': 'Our servers are experiencing issues. Please try again later.',
    'error.payvault.camera_deny': 'Please allow camera access.',
    'error.phone_number.invalid': 'Please enter a correct phone number',
    'error.phone_number.invalid_jp': 'Must contain an area code and local number like 08011112222.',
    'error.phone_number.required': 'Please enter a contact phone number',
    'error.postal_code.required': 'Please enter a valid postal code',
    'error.rakid.boundaries': 'Your username must be between {min} and {max} characters in length',
    'error.rakid.missing': 'Please enter your username',
    'error.rakid.noemail': 'Your username cannot be the same as your current email',
    'error.rakid.nospace': 'Your username cannot contain spaces',
    'error.rakid.letter_number_symbols_point_underscore_midline':
        'Only the following may be used: alphanumeric characters, dots (.), underscores (_), and hyphens (-)',
    'error.rakid_must_include_least_one_letter': 'Must include at least one letter.',
    'error.rakid_not_first_last':
        'Periods (.), underscores (_), and hyphens (-) cannot be used at the beginning or end.',
    'error.mobile_phone.required': 'Please enter a mobile phone number',
    'error.mobile_phone.invalid': 'Please enter a correct mobile phone number',
    'error.mobile_phone.invalid_jp': 'Must contain an area code and local number like 08011112222.',
    'error.rakid_not_contain_consecutive_symbols':
        'The username cannot contain consecutive periods (.), underscores (_), or hyphens (-).',
    'error.rid.invalid':
        'Invalid User ID format. The correct format should contain 8-128 alphanumeric characters. Dashes (-), underscores (_) and periods (.) are allowed.',
    'error.rid.registered': 'Username already exists',
    'error.session_expired':
        'Session timeout detected. Changes you made have not been applied. Please refresh the page and sign in again.',
    'error.short_field_n': 'This field must contain {n} or more characters',
    'error.state.required': 'Please select the State/Prefecture',
    'error.state_US.required': 'Please enter the State',
    'error.unknown':
        "Sorry, we couldn't process your request. Please check what you've entered and try again.",
    'error.unsupported_characters': 'Unsupported characters',
    'error.position_name_required': 'Please enter your department Name/Position',
    'error.mobile_email_address_required': 'Please enter your mobile email',
    'error.wrong_credentials':
        'The email/username and password combination is incorrect. Please try again.',
    'error.fax_name_required': 'Please enter your fax number',
    'error.fax.invalid': 'Please enter a valid fax number',
    'error.cancel_membership_checkbox_japan_required': 'Please check to proceed',
    'error.cancel_membership_checkbox_overseas_required': 'Please check to proceed',
    'gender.disabled_message': 'You cannot change your gender later if you select female or male.',
    'gender.disabled_message_no_csurl':
        'You cannot change your gender later if you select female or male.',
    'label.address_line': 'Address Line {n}',
    'label.address_line_jp': 'Rest of address',
    'label.address_selector': 'Choose a billing address',
    'label.card_number': 'Credit card number',
    'label.city': 'City',
    'label.company_name': 'Company/Organization name',
    'label.country': 'Country',
    'label.mandatory': 'Items marked with * are required.',
    'label.current_email': 'Current email',
    'label.current_password': 'Current password',
    'label.current_rak_id': 'Registered emai',
    'label.day': 'Day',
    'label.dd': 'DD',
    'label.dob': 'Date of birth',
    'label.email': 'Email',
    'label.expiry_date': 'Expiration date',
    'label.first_name': 'First name',
    'label.first_name_kana': 'First name (kana)',
    'label.gender': 'Gender',
    'label.gender.female': 'Female',
    'label.passport_first_name': 'First name as shown on your passport (English)',
    'label.passport_last_name': 'First name as shown on your passport (English)',
    'label.gender.male': 'Male',
    'label.gender.undefined': "I'd rather not say",
    'label.last_name': 'Last name',
    'label.last_name_kana': 'Last name (kana)',
    'label.mm': 'MM',
    'label.month': 'Month',
    'label.month_payment_edit': 'Month (MM)',
    'label.new_email': 'New email ',
    'label.new_pass': 'New password',
    'label.new_rak_id': 'New User ID',
    'label.nickname': 'Nickname',
    'label.optional': '(Optional)',
    'label.owner_name': 'Cardholder name',
    'label.yy': 'YY',
    'label.password': 'Password',
    'label.phone': 'Telephone number',
    'label.phone_number': 'Telephone number',
    'label.mobile_phone': 'Mobile phone number',
    'label.postal_code': 'ZIP/Postal code',
    'label.repeat_password': 'Re-enter new password',
    'label.state': 'State / Prefecture / Province',
    'label.state_US': 'State',
    'label.year': 'Year',
    'label.year_payment_edit': 'Year (YY)',
    'label.yyyy': 'YYYY',
    'label.banchi': 'No Banchi',
    'label.mobile_email': 'Mobile email',
    'label.fax_number': 'Fax number',
    'label.position_name': 'Department name/Position',
    'label.show_password': 'Show password',
    'label.show_new_password': 'Show new password',
    'login.check_email': 'Please follow the instructions in the email just sent you.',
    'notifications.account.deleted': 'Your Rakuten account has been successfully deleted',
    'notifications.account.email.update.failure': 'There was an error updating your email.',
    'notifications.account.email.update.failure.rid-1004':
        "This email address can't be registered.",
    'notifications.account.email.update.failure.rid-1014':
        'One or more of the fields have invalid inputs. ',
    'notifications.account.email.update.failure.myr-6002':
        'The email address / username and password combination is incorrect. Please try again.',
    'notifications.address.add.failure.rid-1004':
        'This mobile email is already registered to an existing account. Please register a different one.',
    'notifications.account.email.update.failure.myr-6016':
        "Sorry, we couldn't process your request. Please check what you've entered and try again.",
    'notifications.account.email.update.success': 'Your email was successfully updated.',
    'notifications.address.add.failure.myr-6016':
        "Sorry, we couldn't process your request. Please check what you've entered and try again.",
    'notifications.account.subscription.update.success':
        'Your preferences were successfully updated.',
    'notifications.account.password.update.failure': 'There was an error updating your password.',
    'notifications.account.password.update.failure.rid-1014':
        'One or more of the fields have invalid inputs. ',
    'notifications.account.password.update.failure.myr-6036':
        "While your password met the strength requirements, we've detected potential security risks. Please use a new password.",
    'notifications.account.password.update.failure.myr-6002':
        'The email address / username and password combination is incorrect. Please try again.',
    'notifications.address.update.failure.rid-1004':
        'This mobile email is already registered to an existing account. Please register a different one.',
    'notifications.account.password.update.failure.myr-6016':
        "Sorry, we couldn't process your request. Please check what you've entered and try again.",
    'notifications.address.update.failure.myr-6016':
        "Sorry, we couldn't process your request. Please check what you've entered and try again.",
    'notifications.account.password.update.success': 'Your password was successfully updated.',
    'notifications.account.password.update.session_revocation_warning':
        'You will be signed out from all devices including this one if you proceed to update your password.',
    'notifications.account.password.update.session_revocation_failed':
        'You could not be signed out due to an error. Please sign out yourself by clicking the "{linkText}" link at the bottom of the {pageName} page.',
    'notifications.account.username.update.failure':
        'There was an error updating your username. Please try again.',
    'notifications.account.username.update.failure.rid-1004':
        'This username is already registered to an existing account.',
    'notifications.account.username.update.failure.rid-1014':
        'One or more of the fields have invalid inputs.',
    'notifications.account.username.update.failure.myr-6002':
        'The email address / username and password combination is incorrect. Please try again.',
    'notifications.account.username.update.failure.myr-6016':
        "Sorry, we couldn't process your request. Please check what you've entered and try again.",
    'notifications.account.username.update.success': 'Your username was successfully updated.',
    'notifications.address.add.failure':
        'There was a problem registering your address. Please try again.',
    'notifications.address.add.failure.rid-1014': 'One or more of the fields have invalid inputs. ',
    'notifications.address.add.failure.rid-1018': 'The limit of 100 addresses has been reached.',
    'notifications.address.add.success': 'Your new address has been successfully registered.',
    'notifications.address.delete.failure':
        'There was a problem saving your changes. Please try again.',
    'notifications.card.update.failure.rid-1004':
        'A card with this number has already been added. Please register another card.',
    'notifications.address.delete.success': 'Your changes were successfully saved.',
    'notifications.address.update.failure':
        'There was a problem saving your changes. Please try again.',
    'notifications.card.update.failure.myr-6016':
        "Sorry, we couldn't process your request. Please check what you've entered and try again.",
    'notifications.address.update.failure.rid-1014':
        'One or more of the fields have invalid inputs. ',
    'notifications.address.update.success': 'Your changes were successfully saved.',
    'notifications.card.add.failure':
        'There was a problem adding your credit/debit card. Please try again.',
    'notifications.personalInformation.update.failure.myr-6016':
        "Sorry, we couldn't process your request. Please check what you've entered and try again.",
    'notifications.card.add.failure.rid-1004':
        'A card with this number already exists. Please register a different card.',
    'notifications.card.add.failure.rid-1014': 'One or more of the fields have invalid inputs. ',
    'notifications.card.add.failure.rid-1018': 'The limit of 10 cards has been reached.',
    'notifications.card.add.failure.myr-6016':
        "Sorry, we couldn't process your request. Please check what you've entered and try again.",
    'notifications.card.add.success': 'Your credit/debit card has been successfully added.',
    'notifications.address_search.not_found': 'Address not found',
    'notifications.card.delete.failure':
        'There was a problem saving your changes. Please try again.',
    'notifications.card.delete.success': 'Your changes were successfully saved.',
    'notifications.card.update.failure':
        'There was a problem saving your changes. Please try again.',
    'notifications.card.update.failure.rid-1014': 'One or more of the fields have invalid inputs.',
    'notifications.try_different_page':
        'There was a problem submitting your request. Please try again later.',
    'notifications.card.update.success': 'Your changes were successfully saved.',
    'notifications.personalInformation.update.failure':
        'There was a problem saving your changes. Please try again.',
    'notifications.card.failure.cannot-be-default-title':
        'This card cannot be set as your Default Card',
    'notifications.card.failure.cannot-be-default-message':
        'Please check the registered card information of the card you want to set as your default card and make sure that the card is not expired and that the currently registered cardholder name exactly matches the name written on the card.',
    'notifications.dsr.update.success': 'Request for account deletion was submitted successfully.',
    'notifications.dsr.update.failure.myr-6002': 'Please enter the correct password.',
    'notifications.dsr.update.failure.myr-6016':
        'Your text does not appear to match the image content. Please try again.',
    'notifications.dsr.update.failure.myr-6000':
        'Failed to submit the request for account deletion. Please try again later.',
    'notifications.dsr.update.failure.myr-6018': 'DSR Request could not be saved.',
    'notifications.dsr.update.failure.myr-6019': 'DSR Deletion is not enabled for the service.',
    'notifications.dsr.update.failure.myr-6021':
        'User already has a delete/download request in progress.',
    'notifications.dsr.update.failure.myr-6022': 'User has a delete/download request in progress.',
    'notifications.dsr.update.failure.myr-6023': 'DSR Download is not enabled for the service.',
    'notifications.dsr.update.failure.myr-6999':
        'There was a problem submitting your request, please try again later.',
    'notifications.personalInformation.update.failure.rid-1004': 'Conflict happened',
    'notifications.personalInformation.update.failure.rid-1014':
        'One or more of the fields have invalid inputs. ',
    'notifications.personalInformation.update.success': 'Your changes were successfully saved.',
    'notifications.redirect.action':
        'You will be automatically moved to the page you were browsing before',
    'notifications.redirect.here': 'here',
    'notifications.redirect.otherwise': 'If not, please click {here}.',
    'notifications.redirect.reason.expired': 'Your session has expired. ',
    'notifications.redirect.time.count0': ' in 0 seconds. ',
    'notifications.redirect.time.count1': ' in 1 second. ',
    'notifications.redirect.time.count2': ' in 2 seconds. ',
    'notifications.redirect.time.count3': ' in 3 seconds. ',
    'notifications.something_went_wrong':
        'There was a problem submitting your request. Please try again later.',
    'notifications.cancelMembership.deleteAccountCancelMember.failure':
        'There was a problem deleting your account. Please try again.',
    'notifications.cancelMembership.deleteAccountCancelMember.failure.myr-6002':
        'Current Password is invalid. Please try again.',
    'notifications.cancelMembership.deleteAccountCancelMember.failure.myr-6016':
        "Sorry, we couldn't process your request. Please check what you've entered and try again. ",
    'p400.code': 'Error 400: Bad request',
    'p400.option': 'Checking',
    'p400.option1':
        'Open Chrome and at the top right, open the menu (3 vertical dots) and select {a}.',
    'p400.option2': 'Under {b}, select {c}.',
    'p400.option3': 'At the top, choose the preferred time range.',
    'p400.option4': 'Check the boxes next to {d} and {e}, and then select {f}.',
    'p400.option.a': 'Settings',
    'p400.option.b': 'Privacy and security',
    'p400.option.c': 'Clear browsing history',
    'p400.option.d': 'Checking',
    'p400.option.e': 'Checking',
    'p400.option.f': 'Clear data',
    'p400.options': '4',
    'p400.operate': 'Delete cookies on {browser}',
    'p400.operate1':
        'Open Microsoft Edge and at the top right, open the menu (3 vertical dots) and select {a}.',
    'p400.operate2': 'Under {b}, choose the preferred time range.',
    'p400.operate3': 'Select {c}, then {d} and {e}, and then select {f}.',
    'p400.operate.a': 'History > Clear browsing history',
    'p400.operate.b': 'Time range',
    'p400.operate.c': 'Browsing history',
    'p400.operate.d': 'Cookies and other site data',
    'p400.operate.e': 'Cached images and files',
    'p400.operate.f': 'Clear now',
    'p400.text':
        'This page can no longer be displayed in the browser you are using. This issue is usually caused by a problem with cookies or an invalid character in the address bar.',
    'p400.text1':
        'This page has automatically deleted the cookies that may have caused this error. Please use the {n} button below to return to the page you were previously viewing. Please note you may be required to sign in again.',
    'p400.text2':
        'If you keep seeing this page, please try again later or follow the steps below to delete the cookies yourself. Please note that deleting the cookies will sign you out of all accounts.',
    'p400.text3':
        'If you’re using a different browser, please refer to the {link} for more information.',
    'p400.text4': 'Help pages (only Japanese available)',
    'p400.title': 'The page could not be displayed',
    'p401.code': 'Error 401: Unauthorized',
    'p401.option': 'Please try the following options',
    'p401.option1': 'Reload the page, or try again later.',
    'p401.option2': 'Check the information you entered to make sure they are correct.',
    'p401.option3': 'Click the back button to try another link.',
    'p401.options': '3',
    'p401.text': "You either supplied the wrong information or they weren't processed correctly.",
    'p401.text1': ' ',
    'p401.title': 'The page you requested could not be displayed',
    'p401.operate': 'Find the page directly from {site}',
    'p403.code': 'Error 403: Forbidden',
    'p403.operate': 'Find the page directly from {site}',
    'p403.option': 'Please try the following options',
    'p403.option1': 'Reload the page, or try again later.',
    'p403.option2': 'Check the address you entered to make sure it is spelled correctly.',
    'p403.option3': 'Click the back button to try another link.',
    'p403.options': '3',
    'p403.text':
        'The page you requested either has restricted access, was deleted, or was moved to a different address.',
    'p403.text1': ' ',
    'p403.title': 'The page you requested has restricted access',
    'p404.code': 'Error 404: Not Found',
    'p404.option': 'Please try the following options',
    'p404.option1': 'Reload the page, or try again later.',
    'p404.option2': 'Check the address you entered to make sure it is spelled correctly.',
    'p404.option3': 'Click the back button to try another link.',
    'p404.options': '3',
    'p404.operate': 'Find the page directly from {site}',
    'p404.text': 'The page you requested may have been moved or deleted.',
    'p404.text1': ' ',
    'p404.title': 'The page you requested was not found',
    'p500.code': 'Error 500: Internal Server Error',
    'p500.option': 'Please try the following options',
    'p500.option1': 'Reload the page, or try again later.',
    'p500.option2': 'Click the back button to try another link.',
    'p500.options': '2',
    'p500.text': ' The server is temporary unavailable due to high traffic or maintenance',
    'p500.text1': ' ',
    'p500.title': 'The content is not accessible due to a server error',
    'p500.operate': 'Find the page directly from {site}',
    'payment.default': 'Default',
    'payment.delete': 'Delete card',
    'payment.delete_confirmation.warning_bottom_default': ' ',
    'payment.delete_confirmation.warning_top': 'You are about to delete your card.',
    'payment.delete_confirmation.warning_top_default': 'You are about to delete your default card.',
    'payment.delete_confirmation.disclaimer':
        'Deleting this card will permanently remove the card and any related agreements with Rakuten services from your account.',
    'payment.delete_confirmation.disclaimer_subscription':
        'Please verify if you have any active subscriptions utilizing this card, and take necessary action before proceeding.',
    'payment.edit': 'Edit card',
    'payment.make_default': 'Default',
    'points.available.balance': 'Available Points',
    'payment.new': 'Add card',
    'points.pending.balance': 'Pending Points',
    'payment.new_limit_reached': 'Card registration limit reached',
    'payment.card_number': 'Last 4 digits',
    'points.balance': 'Your points balance',
    'points.details': 'Details',
    'points.earned.spent': 'Earned / Spent',
    'points.earned': 'Earned',
    'points.expiring.day': 'day',
    'points.expiring.days': 'days',
    'points.expiring.title': 'Expiring Points',
    'points.expiring.today': 'Today',
    'points.expiring': 'Expiring',
    'points.history': 'Your transaction history',
    'points.no_fetch': 'Unable to fetch transaction history at this time',
    'points.no_history': 'No transactions found',
    'points.to.eur': 'To {currency}',
    'points.to.sp': 'To Points',
    'points.no.expiring': 'No points are due to expire soon',
    'points.order.details': 'Order details',
    'points.order.number': 'Order number',
    'points.cashback.available.balance': 'Available',
    'points.cashback.pending.balance': 'Pending',
    'points.cashback': 'Cashback',
    'points.cashback.cash': 'Cash',
    'points.cashback.cashback_type': 'Cashback type',
    'points.cashback_and_points': 'Cashback and Points',
    'points.currency': 'Currency',
    'points.points': 'Points',
    'points.service': 'Service',
    'points.spent': 'Spent',
    'points.standard': 'Standard',
    'points.transaction.date': 'Transaction date',
    'points.type': 'Point type',
    'points.gpp.error.message':
        'Sorry, could not read the information about Points Activity. Please try to reload the page later.',
    'cashback.gpp.error.message':
        'Sorry, could not read the information about Cashback and Points. Please try to reload the page later.',
    'profile.account': 'Account and Security',
    'overview.home': 'Overview',
    'profile.addresses': 'Address and Contact',
    'profile.back_to_return_url': 'Back to Shop',
    'profile.edit_info': 'Manage your personal information (name, birthday, etc.)',
    'profile.have': 'Points Balance',
    'profile.info': 'Personal Information',
    'profile.manage_account':
        'Manage your verified information (username, email, password) or cancel your Rakuten membership',
    'profile.manage_address': 'Manage your address, telephone number, mobile phone number etc',
    'profile.manage_payment': 'Manage your credit card information',
    'profile.payment': 'Payment Method',
    'profile.points_check': 'Check the points you have received and exchanged',
    'profile.points_club': 'PointClub',
    'profile.services': 'Rakuten Services',
    'rakservice.privacy': 'Privacy',
    'profile.view_services': 'View all available Rakuten services in your region',
    'profile.ucrm': 'Services & Privacy',
    'profile.view_ucrm': 'Manage all your consents to Rakuten services',
    'profile.linked_accounts': 'Social Account Linkage Management',
    'profile.view_linked_accounts': 'Manage your social account linkage',
    'ucrm.top.title': 'Manage your permissions',
    'ucrm.top.description_1': 'At ',
    'ucrm.top.description_2': 'Rakuten',
    'ucrm.top.description_3':
        ', we want you to decide what your data is used for and whether or not it can be shared. We use your data to help make your experience better and personalize it  through recommendations and advertisements. Using the options below, you can control which data we will use to do this. You can change these options at any time.',
    'ucrm.bottom.eu.services': 'Discover more Rakuten services in Europe',
    'ucrm.other.linked.services': 'Other linked services',
    'ucrm.your.linked.services': 'Your Linked Services',
    'ucrm.contact.us.text': 'Trouble with your Services & Privacy? Contact us at ',
    'rakservice.check.cp': 'Cookie Policy',
    'rakservice.check.check': 'Check ',
    'privacy.check_specific_privacy_settings': 'Check specific privacy settings of the service',
    'rakservice.check.others': 'Other Rakuten Services',
    'rakservice.check.pp': 'Privacy Policy',
    'rakservice.check.tc': 'Terms and Conditions',
    'rakservice.check.tnc': 'Terms and Conditions',
    'rakservice.delete_confirmation.title': 'Are you sure you want to delete your Rakuten account?',
    'rakservice.delete_confirmation.warning':
        "All your information on Rakuten (including transaction history) will be deleted. You will also lose any Rakuten Points that you've earned. You will not be able to recover them later.",
    'rakservice.delete_confirmation.title.line': '{username} さん',
    'rakservice.delete_confirmation.warning.red.line.one':
        "If you cancel your Rakuten membership, both your currently held Points and any Points you're scheduled to earn will expire, and your membership rank will be invalidated.",
    'rakservice.delete_confirmation.warning.red.line.two':
        "Once you cancel your membership, you can't restore it. You also can't integrate or transfer it to another Rakuten account even if you contact Customer Support.",
    'rakservice.delete_confirmation.warning.top':
        'Are you sure you want to cancel your Rakuten membership?',
    'rakservice.intro.default': 'You are a registered member of {serviceName}.',
    'rakservice.intro.rakutentv':
        'Enjoy the latest releases on your SMART TV and many other devices in just a few clicks. The best blockbusters, award-winning classics and series instantly. No contracts or commitments. Try it now and earn Rakuten Super Points with every purchase you make.',
    'rakservice.newsletter.default':
        'Send me regular newsletters with the best offers on the internet.',
    'rakservice.newsletter.viber':
        'Send me regular newsletters about latest improvements in Viber app and service.',
    'rakservice.newsletter_success': 'Successfully subscribed to Newsletter',
    'tooltip.default_address.activated':
        'This address is set as the default for shipping. You can only deselect it by setting a different address as the default.',
    'tooltip.default_address.create':
        'By setting this as your default shipping address, your current default shipping address will be replaced.',
    'tooltip.default_address.create.only':
        'As this is the only address in your profile, it will be set as the default for shipping.',
    'tooltip.default_address.deactivated':
        'Use this button to set this address as the default for shipping',
    'tooltip.default_address.edit':
        'This address will be set as the default for shipping. It will only be replaced when another address is set as the default.',
    'tooltip.default_card':
        'By setting this as your default card, your current default card will be replaced.',
    'tooltip.default_card.activated':
        'This card is set as your default payment method. You can only deselect it by setting a different card as the default.',
    'tooltip.default_card.create':
        'By setting this as your default card, your current default card will be replaced.',
    'tooltip.default_card.create.only':
        'As this is the only card in your profile, it will be set as your default payment method.',
    'tooltip.default_card.deactivated':
        'Use this button to set this card as your default payment method.',
    'tooltip.default_card.edit':
        'This card will be set as your default payment method. It will be replaced only by setting a different card as the default.',
    'tooltip.delete_address_linked_to_cards':
        'You cannot delete this address as it is linked to one of your payment cards',
    'tooltip.phone_number':
        'Users who only have a mobile phone may enter their mobile phone number',
    'tooltip.address.limit_reached':
        'You have reached the limit of 100 addresses. Please delete some address before adding a new one',
    'tooltip.payment.limit_reached':
        'You have reached the limit of 10 cards. Please delete some card before adding a new one',
    'tooltip.nickname':
        'Anyone can see this nickname; do not use your legal name, email address, or other personal information for your nickname.',
    'tooltip.revoke_session':
        'You might not be signed out from some services. In this case, please sign out from them manually.',
    'transactionGroup.month': 'This month',
    'transactionGroup.period': 'Transactions {period}',
    'transactionGroup.today': 'Today',
    'transactionGroup.week': 'This week',
    'unsubscribe.failure':
        'Sorry, something went wrong while processing your unsubscribe request. Please send an email to uk-support@rakuten.desk-mail.com',
    'unsubscribe.success': 'Your email account has been unsubscribed',
    'label.radio.email': 'Use my email as my username',
    'label.radio.not_email': 'Use a username other than my email',
    'label.username.header': 'Please select the ID to use when logging in to the member service',
    'account.username.same.email.text': 'Use my email as my username',
    'cancel.membership.link.eu': 'Go to Services & Privacy to delete my account on linked services',
    'cancel.membership.link': 'Cancel Rakuten Membership',
    'cancel.membership.top.title':
        'Please read this page carefully before cancelling your membership. ',
    'cancel.membership.top.description':
        "Once you cancel your membership, you can't restore it. You also can't integrate or transfer it to another Rakuten account even if you contact Customer Support.",
    'cancel.membership.subTitle1':
        "If you cancel your Rakuten membership, some or all of the following will come into effect for the Rakuten services you're using.",
    'cancel.membership.subTitle2':
        'Your Rakuten Points (both current and to be granted) and Rakuten Cash will all expire upon membership cancellation',
    'cancel.membership.subBottomTitle1': 'Rakuten services in Japan',
    'cancel.membership.subBottomTitle2': 'Rakuten services overseas',
    'cancel.membership.checkboxJapanService':
        'I have checked the terms of Rakuten services in Japan ',
    'cancel.membership.checkboxOverseaServices':
        'I have checked the terms of Rakuten services overseas',
    'cancel.membership.topPartOneUlOne':
        'Although the service will no longer be available, you can continue to browse content within the service.',
    'cancel.membership.topPartOneUlTwo':
        'The service will become unavailable and the content in the service will also be deleted.',
    'cancel.membership.topPartOneUlThree':
        'You can continue to use the service, but you cannot link it with other Rakuten services. (If you want to terminate any other service agreement, a separate procedure is required.)',
    'cancel.membership.topPartOneUlFour':
        'Cancelling your Rakuten Membership will also result in the deactivation of your Rakuten ID.',
    'cancel.membership.topPartOneUlFive':
        'Please check our Privacy Policy on our data retention policy for Rakuten ID. {pravicyUrl}',
    'cancel.membership.pravicyUrl': 'https://privacy.rakuten.co.jp/english/',
    'cancel.membership.topPartTwoUlOne':
        "Points from the terminated account can't be transferred to another Rakuten account.",
    'cancel.membership.topPartTwoUlTwo':
        "If you cancel your membership but continue to use Rakuten Card, you won't be awarded Rakuten Points for using it or from campaigns. Any Rakuten Points you may have earned up until now cannot be transferred to another Rakuten account.",
    'cancel.membership.topPartTwoUlThree': 'Rakuten Edy will continue to be available.',
    'cancel.membership.JapanPointUrl': 'Check my current Rakuten points',
    'cancel.membership.TaiwanPointUrl': '',
    'cancel.membership.externalPointUrl': '{JapanPointUrl}',
    'cancel.membership.topPartThree':
        'Please read the "terms" in the next section to check the impact on each service.',
    'cancel.membership.bottomTitle': 'Confirmation of terms ',
    'cancel.membership.bottomTopline1':
        'If you cancel your Rakuten membership, you will not be able to use some Rakuten services in Japan or overseas. Other effects of canceling your membership are described below.',
    'cancel.membership.bottomTopline2': 'Please check the terms below to proceed.',
    'cancel.membership.overseaServicesline1':
        'If you cancel your Rakuten membership, you will not be able to use Rakuten services in Taiwan or overseas. Canceled memberhships cannot be restored.',
    'cancel.membership.overseaServicesline2':
        "Please check the terms below to proceed. Even if you're only using Rakuten services in Japan, please check both boxes.",
    'cancel.membership.japanServiceError': 'Please check to proceed',
    'cancel.membership.overseasServiceError': 'Please check to proceed',
    'tw.cancel.membership.link': 'Cancel Rakuten Membership',
    'tw.cancel.membership.top.title':
        'Please read this page carefully before cancelling your membership. ',
    'tw.cancel.membership.top.description':
        "Once you cancel your membership, you can't restore it. You also can't integrate or transfer it to another Rakuten account even if you contact Customer Support.",
    'tw.cancel.membership.subTitle1':
        "If you cancel your Rakuten membership, some or all of the following will come into effect for the Rakuten services you're using.",
    'tw.cancel.membership.subTitle2':
        'Your Rakuten Points (both current and to be granted) and Rakuten Cash will all expire upon membership cancellation.',
    'tw.cancel.membership.subBottomTitle1': 'Rakuten services in Japan',
    'tw.cancel.membership.subBottomTitle2': 'Rakuten services in Taiwan and overseas',
    'tw.cancel.membership.checkboxJapanService':
        'I have checked the terms of Rakuten services in Japan',
    'tw.cancel.membership.checkboxOverseaServices':
        'I have checked the terms of Rakuten services overseas (including Taiwan)',
    'tw.cancel.membership.topPartOneUlOne':
        'Although the service will no longer be available, you can continue to browse content within the service.',
    'tw.cancel.membership.topPartOneUlTwo':
        'The service will become unavailable and the content in the service will also be deleted.',
    'tw.cancel.membership.topPartOneUlThree':
        'You can continue to use the service, but you cannot link it with other Rakuten services. (If you want to terminate any other service agreement, a separate procedure is required.)',
    'tw.cancel.membership.topPartTwoUlOne':
        'Rakuten Points from the terminated account cannot be transferred to another account.',
    'tw.cancel.membership.topPartTwoUlTwo':
        'If you cancel your Rakuten membership, all your Rakuten Points (both current and to be granted) will expire. You will also not be able to earn points from events such as special campaigns. ',
    'tw.cancel.membership.topPartTwoUlThree': 'You can continue to use Rakuten Edy. ',
    'tw.cancel.membership.JapanPointUrl': 'Check my current Rakuten points',
    'tw.cancel.membership.TaiwanPointUrl': '',
    'tw.cancel.membership.externalPointUrl':
        'Check how many Rakuten Points you currently hold:  \nTaiwan Points: {TaiwanPointUrl} \nJapan Points: {JapanPointUrl}',
    'tw.cancel.membership.topPartThree':
        'Please read the "terms" in the next section to check the impact on each service.',
    'tw.cancel.membership.bottomTitle': 'Confirmation of terms',
    'tw.cancel.membership.bottomTopline1':
        'If you cancel your Rakuten membership, you will not be able to use Rakuten services in Taiwan or overseas. Canceled memberhships cannot be restored.',
    'tw.cancel.membership.bottomTopline2': 'Please check the terms below to proceed.',
    'tw.cancel.membership.overseaServicesline1':
        'Please note that if you cancel your Rakuten membership, you will no longer be able to use Rakuten services overseas, as well as other effects described in the document below.',
    'tw.cancel.membership.overseaServicesline2':
        'For details, please read the "Notes" at the bottom and check.Even if you are only using services in Japan, please check  "I have confirmed the precautions", and proceed to the next step.',
    'tw.cancel.membership.japanServiceError': 'Please check to proceed',
    'tw.cancel.membership.overseasServiceError': 'Please check to proceed',
    'tw.travel.cancel.membership.link': 'Cancel Rakuten Membership',
    'tw.travel.cancel.membership.top.description':
        "Once you cancel your membership, you can't restore it. You also can't integrate or transfer it to another Rakuten account even if you contact Customer Support.",
    'tw.travel.cancel.membership.subTitle1':
        "If you cancel your Rakuten membership, some or all of the following will come into effect for the Rakuten services you're using.",
    'tw.travel.cancel.membership.subTitle2':
        'Your Rakuten Points (both current and to be granted) and Rakuten Cash will all expire upon membership cancellation.',
    'tw.travel.cancel.membership.subBottomTitle1': 'Rakuten services in Japan',
    'tw.travel.cancel.membership.subBottomTitle2': 'Rakuten services in Taiwan and overseas',
    'tw.travel.cancel.membership.topPartOneUlOne':
        'Although you can no longer use the service, you can still browse the content within the service. ',
    'tw.travel.cancel.membership.topPartOneUlTwo':
        'You will no longer be able to use the service, and your saved information will be deleted. ',
    'tw.travel.cancel.membership.topPartOneUlThree':
        'You can continue to use the service, but you cannot link it with other Rakuten services. (If you want to terminate any other service agreement, a separate procedure is required.)',
    'tw.travel.cancel.membership.topPartTwoUlOne':
        'Rakuten Points from the terminated account cannot be transferred to another account.',
    'tw.travel.cancel.membership.topPartTwoUlTwo':
        'If you cancel your Rakuten membership, all your Rakuten Points (both current and to be granted) will expire. You will also not be able to earn points from events such as special campaigns. ',
    'tw.travel.cancel.membership.topPartTwoUlThree': 'You can continue to use Rakuten Edy.',
    'tw.travel.cancel.membership.JapanPointUrl': 'PointClub',
    'tw.travel.cancel.membership.TaiwanPointUrl': '樂天點數俱樂部',
    'tw.travel.cancel.membership.externalPointUrl':
        'Check how many Rakuten Points you currently hold:  \nTaiwan Points: {TaiwanPointUrl} \nJapan Points: {JapanPointUrl}',
    'tw.travel.cancel.membership.topPartThree':
        'Please be sure to read the "Term" at the bottom to check the impact on each service.',
    'tw.travel.cancel.membership.top.title':
        'Please read this page carefully before cancelling your membership. ',
    'tw.travel.cancel.membership.bottomTitle': 'Confirmation of terms ',
    'tw.travel.cancel.membership.bottomTopline1':
        'If you cancel your Rakuten membership, you will not be able to use Rakuten services in Taiwan or overseas. Canceled memberhships cannot be restored.',
    'tw.travel.cancel.membership.bottomTopline2': 'Please check the terms below to proceed.',
    'tw.travel.cancel.membership.checkboxJapanService':
        'I have checked the terms of Rakuten services in Japan',
    'tw.travel.cancel.membership.checkboxOverseaServices':
        'I have checked the terms of Rakuten services overseas (including Taiwan)',
    'tw.travel.cancel.membership.overseaServicesline1': ' ',
    'tw.travel.cancel.membership.overseaServicesline2': ' ',
    'tw.travel.cancel.membership.japanServiceError': 'Please check to proceed',
    'tw.travel.cancel.membership.overseasServiceError': 'Please check to proceed',
    'account.security.external.link.secret_question_answer': 'Set up',
    'account.security.security_header': 'Security',
    'account.security.account_header': 'Account',
    'account.security.email2FA.info_text1':
        'As an enhanced security measure, you might be asked to enter a verification code sent to your email in order to update your username, email, or password. (You may also be asked to sign in.)',
    'account.security.external.link.secret_question_answer_label': 'Security question',
    'account.security.email2FA.action.enroll': 'Enable',
    'account.security.label.enabled': 'Enabled',
    'account.security.label.disabled': 'Disabled',
    'account.security.external.link.email_details': 'Details',
    'account.security.external.link.passkey': 'Passkey Management',
    'account.security.external.link.email_label': 'Email 2FA',
    'account.security.passkey.label': 'Passkey',
    'account.security.external.link.login_alert': 'Confirm configuration of Login Alert',
    'menu.page.top.title': 'My Rakuten Account Management',
    'menu.page.top.tip.of.title':
        'You can check and change your registered information such as your name, email, and addresses.',
    'top.page.mydata.title': 'myData',
    'top.page.tip.of.mydata.title':
        'Manage your lifestyle data used in different membership programs',
    'top.page.oam.title': 'Device Management',
    'top.page.tip.of.oam.title': 'Manage the devices you use to sign in without a password',
    'top.page.to.external.bank.text': 'Find information on how to ',
    'top.page.to.external.bank.link.text': 'link your Rakuten membership and Rakuten Bank accounts',
    'address.email.info': '*Other emails can be changed from "Account and Security" in the menu.',
    'button.confirm': 'Confirm',
    'error.re_auth': 'The session has expired. Please sign in again.',
    blank: '',
    'travel_everest.cancel.membership.subTitle3':
        'Even if you terminate your Rakuten Membership, your scheduled bookings are still valid.',
    'travel_everest.cancel.membership.topPartThreeUlOne':
        'Bookings made with the terminated account can no longer be managed or viewed online.',
    'travel_everest.cancel.membership.topPartThreeUlTwo':
        'Your bookings will not be automatically canceled even if you cancel your membership. However, you will no longer receive emails, such as booking confirmation emails.',
    'travel_everest.cancel.membership.topPartThreeUlThree':
        'If you cancel your Rakute membership, bookings made with that account will not be eligible for Points. ',
    'travel_everest.cancel.membership.JapanPointUrl': 'View your booking confirmation page.',
    'travel_everest.cancel.membership.externalPointUrl': '{JapanPointUrl}',
    'travel_standard.cancel.membership.subTitle3':
        'Even if you terminate your Rakuten Membership, your scheduled bookings are still valid.',
    'travel_standard.cancel.membership.topPartThreeUlOne':
        'Bookings made with the terminated account can no longer be managed or viewed online.',
    'travel_standard.cancel.membership.topPartThreeUlTwo':
        'Your bookings will not be automatically canceled even if you cancel your membership. However, you will no longer receive emails, such as booking confirmation emails.',
    'travel_standard.cancel.membership.topPartThreeUlThree':
        'If you cancel your Rakute membership, bookings made with that account will not be eligible for Points. ',
    'travel_standard.cancel.membership.JapanPointUrl': 'View your booking confirmation page.',
    'travel_standard.cancel.membership.externalPointUrl': '{JapanPointUrl}',
    'top.title': 'My Rakuten Account Management',
    'profile.title': 'Personal Information - My Rakuten Account Management',
    'account.title': 'Account and Security - My Rakuten Account Management',
    'address.title': 'Address and Contact - My Rakuten Account Management',
    'payment.title': 'Payment Method - My Rakuten Account Management',
    'cancel.title': 'Cancel Rakuten Membership - My Rakuten Account Management',
    'address.eu.title': 'Addresses - Rakuten Account Management',
    'ucrm.title': 'Services & Privacy - Rakuten Account Management',
    'cashback.points.title': 'Cashback and Points - Rakuten Account Management',
    'points.title': 'Points - Rakuten Account Management',
    'suggestion.email': 'Did you mean {emailUsername}{suggestedDomain}?',
    'close.ariaLabel': 'Close',
    'newTab.ariaLabel': 'Opens in new tab',
    'email.verified': 'Verified',
    'email.not.verified': 'Not verified',
    'email.verify.title': 'Verify your email address',
    'email.verify.newEmailTitle': 'Verify your new email address',
    'email.verify.limitTitle': 'Request limit reached',
    'email.verify.sendOtpFailedTitle': 'Cannot send verification code',
    'email.verify.about': 'About email verification',
    'email.verify.link': 'Please verify your email address.',
    'email.verify.button': 'Verify email address',
    'email.verify.prompt':
        'We have sent a verification code to {verifyingEmail}. It will be valid for 10 minutes.',
    'email.verify.code': 'Verification code',
    'email.verify.required': ' (Required)',
    'email.verify.notReceive': 'Didn’t receive the code? ',
    'email.verify.send': 'Send it again.',
    'email.verify.countDownTimer': 'Resend verification code in {time}.',
    'email.verify.sendSuccess': 'New code sent successfully.',
    'email.verify.codeInvalid': 'Verification code is invalid.',
    'email.verify.exceeded': 'You’ve exceeded the number of allowed attempts.',
    'email.verify.sendCodeAfterFailed': 'Request a new code',
    'email.verify.editEmail': 'Edit email address ',
    'email.verify.sendLimit':
        'You’ve reached the limit for sending verification codes. Please wait a while before trying again.',
    'email.verify.sendLimit_two':
        'You can enter the code previously sent to you below. It is valid for 10 minutes.',
    'email.verify.sendFailed':
        "We couldn't send the verification code to {email}. Please check your email address or request a new code. {br}If this error persists, please wait a while and try again later.",
    'email.verify.sendFailedLimit':
        "We couldn't send the verification code to {email}. Please wait awhile and try again later.",
    'email.verify.sending': 'Sending...',
    'email.verify.hintText': 'It takes time before we can display the email verification status.',
    'ekyc.title': 'Identity Verification - Rakuten Account Management',
    'ekyc.service.myr_jpn': 'eKYC test',
    'ekyc.service.wallet': 'Rakuten Pay',
    'ekyc.service.rakuten_wallet_mobile': 'Rakuten Wallet',
    'ekyc.service.rakuten_wallet_passkey_mobile': 'Rakuten Wallet',
    'ekyc.service.rmn_app_android': 'Rakuten Mobile',
    'ekyc.service.rmn_app_ios': 'Rakuten Mobile',
    'ekyc.service.fril_android': 'Rakuten Rakuma',
    'ekyc.service.fril_ios': 'Rakuten Rakuma',
    'ekyc.popup.title': 'Unlink My Number Card',
    'ekyc.popup.description1.wallet':
        'Unlinking your My Number Card from Rakuten Pay after you start using Rakuten Cash Premium (楽天キャッシュ【プレミアム型】) may result in its use being restricted in the Rakuten Pay and Rakuten Rakuma apps.',
    'ekyc.popup.description2.wallet':
        'You will need to complete your identity verification on the apps to use it again.',
    'ekyc.popup.description3.wallet': ' ',
    'ekyc.popup.description1.rakuten_wallet_mobile':
        'Unlinking your My Number Card from Rakuten Wallet removes your identification status and you may not be able to use the service anymore.',
    'ekyc.popup.description2.rakuten_wallet_mobile':
        'In this case, your current account with Rakuten Wallet will be closed. Any crypto asset in your account will be sold with the money refunded to you in Japanese yen on a date specified by Rakuten Wallet, Inc.',
    'ekyc.popup.description3.rakuten_wallet_mobile':
        'If you want to use this service again, you will need to submit a new application.',
    'ekyc.popup.description1.rakuten_wallet_passkey_mobile':
        'Unlinking your My Number Card from Rakuten Wallet removes your identification status and you may not be able to use the service anymore.',
    'ekyc.popup.description2.rakuten_wallet_passkey_mobile':
        'In this case, your current account with Rakuten Wallet will be closed. Any crypto asset in your account will be sold with the money refunded to you in Japanese yen on a date specified by Rakuten Wallet, Inc.',
    'ekyc.popup.description3.rakuten_wallet_passkey_mobile':
        'If you want to use this service again, you will need to submit a new application.',
    'ekyc.popup.description1.rmn_app_android':
        'This action will remove the link of your identity verification results between Rakuten Mobile and your Rakuten Account.',
    'ekyc.popup.description2.rmn_app_android':
        "You will still be able to use Rakuten Mobile, as your data remains stored in Rakuten Mobile's database due to legal requirements. However, removing this link may affect your ability to use other services that require identity verification in the future.",
    'ekyc.popup.description3.rmn_app_android':
        'If you have identity verification results from other services that are linked to your Rakuten Account, nothing will be affected.',
    'ekyc.popup.description1.rmn_app_ios':
        'This action will remove the link of your identity verification results between Rakuten Mobile and your Rakuten Account.',
    'ekyc.popup.description2.rmn_app_ios':
        "You will still be able to use Rakuten Mobile, as your data remains stored in Rakuten Mobile's database due to legal requirements. However, removing this link may affect your ability to use other services that require identity verification in the future.",
    'ekyc.popup.description3.rmn_app_ios':
        'If you have identity verification results from other services that are linked to your Rakuten Account, nothing will be affected.',
    'ekyc.popup.description1.fril_android':
        'This action will remove the link of your identity verification results between Rakuten Rakuma and your Rakuten Account.',
    'ekyc.popup.description2.fril_android':
        "You will still be able to use Rakuten Rakuma, as your data remains stored in Rakuten Rakuma's database due to legal requirements. However, removing this link may affect your ability to use other services that require identity verification in the future.",
    'ekyc.popup.description3.fril_android':
        'If you have identity verification results from other services that are linked to your Rakuten Account, nothing will be affected.',
    'ekyc.popup.description1.fril_ios':
        'This action will remove the link of your identity verification results between Rakuten Rakuma and your Rakuten Account.',
    'ekyc.popup.description2.fril_ios':
        "You will still be able to use Rakuten Rakuma, as your data remains stored in Rakuten Rakuma's database due to legal requirements. However, removing this link may affect your ability to use other services that require identity verification in the future.",
    'ekyc.popup.description3.fril_ios':
        'If you have identity verification results from other services that are linked to your Rakuten Account, nothing will be affected.',
    'ekyc.top.description':
        "Services where you've completed identity verification using My Number Card are displayed below.",
    'ekyc.top.description2':
        'To unlink your My Number Card from a service, please use the "Unlink" button below.',
    'profile.ekyc': 'Identity Verified Services',
    'profile.manage_ekyc':
        "Manage services where you've completed identity verification using My Number Card",
    'ekyc.info.title': 'Important notes',
    'ekyc.mynumber.info':
        'Please check the service page for the latest information as the status may differ from that displayed for each service.',
    'ekyc.unlink.info':
        "If you unlink your My Number Card from a service, you might not be able to use the whole or part of that service. If you'd like to fully use that service again, you will need to verify your identity once more.",
    'ekyc.service.info': 'Each Rakuten account can only be linked to one My Number Card. ',
    'ekyc.help.info': 'Please refer to the',
    'ekyc.help.link': 'Help page',
    'ekyc.help.warning': ' (only available in Japanese) for more details.',
    'notifications.ekyc.unlink.failure.myr-6002': 'Current Password is invalid. Please try again.',
    'notifications.ekyc.unlink.success':
        'Your My Number Card has been successfully unlinked from the service.',
    'notifications.ekyc.unlink.failure':
        "Sorry, we couldn't process your request. Please check what you've entered and try again.",
    'notifications.ekyc.unlink.failure.myr-6016':
        "Sorry, we couldn't process your request. Please check what you've entered and try again.",
    'visitor.get.started': 'Get started',
    'visitor.signup.rakuten.btn': 'Create a Rakuten ID',
    'visitor.signin.rakuten.btn': 'I have an ID, manage my account',
    'visitor.signup.my.id.btn': 'My ID',
    'visitor.main.heading.1': 'Your Rakuten Account,',
    'visitor.main.heading.2': 'your ID for all of Rakuten and partners',
    'visitor.info.heading.1': 'One Rakuten ID to access all',
    'visitor.info.body.1':
        'Every day, more services are connecting to your Rakuten Account to bring you a seamless experience on any device.',
    'visitor.info.heading.2': 'You are in control',
    'visitor.info.body.2':
        'With My Rakuten, you have one place to manage your Rakuten Account, what you own and what you share at any time.',
    'visitor.info.heading.3': 'Privacy and Security',
    'visitor.info.body.3':
        'Rakuten takes your privacy very seriously and protects your data by following the highest international standards.',
    'visitor.rakuten.tv.title': 'Watch films and TV shows with no subscription',
    'visitor.rakuten.tv.body':
        'Enjoy your favourite films in HD and 4K picture quality, on the device of your choice. Rakuten TV is available on smart TVs, smartphones, and both windows and Mac computers.',
    'visitor.rakuten.tv.heading':
        'Watch the latest releases and tons of free movies from any device',
    'visitor.rakuten.tv.action': 'Watch',
    'visitor.rakuten.viber.title': 'Connect with people from all over the world, securely',
    'visitor.rakuten.viber.body':
        'Every month, hundreds of millions of people use Viber to connect, for free, with their loved ones via messaging, high-quality voice and video calls and more. All Viber calls and chats are protected by built-in end-to-end encryption, so you can be sure your conversations are always secure.',
    'visitor.rakuten.viber.heading':
        'Connect with people securely: messaging or high quality voice and video calls',
    'visitor.rakuten.viber.action': 'Chat',
    'visitor.rakuten.kobo.title': 'Choose from over 5 million titles',
    'visitor.rakuten.kobo.body':
        "The Rakuten Kobo e-library is endless, and it's growing. You'll find every type of eBook imaginable, from yesterday's classics to today's bestsellers, as well as an expertly curated collection of audiobooks. Discover recommendations for books - the perfect read is right here waiting for you.",
    'visitor.rakuten.kobo.heading':
        'Choose from an e-library of over 5 million titles. The perfect read is here',
    'visitor.rakuten.kobo.action': 'Read',
    'visitor.rakuten.sites.title': 'Be rewarded as you enjoy',
    'visitor.rakuten.sites.body':
        'With Rakuten you receive money back when buying from your favourite stores. Every time you place an order or make a reservation through our affiliate platform, we give you a percentage of the order value back. In addition, you can find a selection of current offers and coupons, so you can save the most on your online purchases.',
    'visitor.rakuten.sites.heading':
        'Be rewarded with Cashback and Points as you enjoy shopping or joining exciting experiences',
    'visitor.rakuten.sites.action': 'Shop',
    'visitor.rakuten.france.title':
        'Leader in guaranteed e-commerce for new or second-hand products',
    'visitor.rakuten.france.body':
        "Rakuten brings together the largest selection of low-cost products on the web, including both new and used items. We provide a rich catalogue with plenty of quality items and services. Benefit from an after-sales service that's always on hand, secured purchases and delivery, at home or pick-up points, and all while enjoying a rewarding loyalty program. Rakuten, pioneer of the collaborative and circular economy.",
    'visitor.rakuten.france.heading':
        'Leader in guaranteed e-commerce for new or second-hand products',
    'visitor.rakuten.france.action': 'France - Shop',
    'visitor.rakuten.pay.title': 'Pay easily and save money',
    'visitor.rakuten.pay.body':
        'Rakuten Pay is a mobile QR Code payment App that provides a seamless checkout process with Rakuten ID and opportunities to save money with Rakuten Points (earn & redeem)',
    'visitor.rakuten.pay.heading':
        'Pay seamlessly by scanning a QR code and save money with Rakuten Points',
    'visitor.rakuten.pay.action': 'Pay',
    'visitor.rakuten.goto.link': 'Go To {linkText}',
    'privacy.policy': 'Privacy Policy',
    'cookie.policy': 'Cookies Policy',
    'cookie.last.update': 'Last Updated: May, 1st 2022',
    'cookie.description.1':
        'Rakuten Group, Inc., based in Tokyo, Japan, is the company operating the {link1} pages (“My Rakuten Account”, “My Rakuten” or “MyR”). More information about Rakuten is available at {link2} (“Rakuten”, “We”, “Our” and/or “Us”).',
    'cookie.description.2':
        "This Cookies Policy describes what cookies are used on the Rakuten and other sites that link to this Cookies Policy (the ''Sites''), why they are used and how you can control their use.",
    'cookie.description.3': 'Please read this Cookies Policy carefully.',
    'cookie.description.4': ' ',
    'cookie.heading.1': '1. What is a cookie?',
    'cookie.heading.1.description.1':
        'When you navigate on the Rakuten pages, we collect some data, notably about the operating system, browser or device (computer, tablet or mobile phone) that you use, the location data (notably parts of your IP address) or also data related to your interactions with the Rakuten page (visited pages, parts of the pages where you click).',
    'cookie.heading.1.description.2':
        'These navigation data are collected via cookies or other similar devices, such as « pixel tags ». In this policy, all these devices are designated as « cookies ».',
    'cookie.heading.2': '2. What types of cookies do we use?',
    'cookie.heading.2.description.1':
        'These cookies are either directly placed by us, either placed by a partner.',
    'cookie.heading.2.subheading.1': '2.1 Necessary cookies',
    'cookie.heading.2.subheading.1.description.1':
        'These cookies are essential for you to browse the website and use its features, for example:',
    'cookie.heading.2.subheading.1.point.1':
        'To store the information of the user in order to provide the user’s account features.',
    'cookie.heading.2.subheading.1.point.2': 'To secure the website.',
    'cookie.heading.2.subheading.1.point.3': 'To enable some features of the website.',
    'cookie.heading.2.subheading.2': '2.2 Analytics cookies',
    'cookie.heading.2.subheading.2.description.1':
        'Those are the cookies that allow us to know the use and the performances of the website, in order to improve its functioning:',
    'cookie.heading.2.subheading.2.point.1': 'Rakuten Analytics Tracker (RAT)',
    'cookie.heading.3': '3. Uninstalling cookies',
    'cookie.heading.3.description.1':
        'If you do not want us or our partners to collect information through the use of cookies, you can set up your choices via the Cookies settings page {link1} at any time.',
    'cookie.heading.4': '4. Changes to the Cookies Policy',
    'cookie.heading.4.description.1':
        'We can modify the cookies policy at any time. As changes may occur, please check this information periodically.',
    'cookie.heading.5': '5. Contact',
    'cookie.heading.5.description.1':
        'If you have any request or concern, please send us your request at {link1}.',
    'home.intro': 'Discover Rakuten services in Europe',
    'germany.name': 'Germany',
    'spain.name': 'Spain',
    'uk.name': 'UK',
    'ukraine.name': 'Ukraine',
    'viber.image.alt': 'A father is teleworking with his son and calls using Rakuten Viber',
    'kobo.image.alt': 'A young woman relaxes on a hammock while reading an e-book by Rakuten Kobo',
    'france.image.alt': 'A young man opens a box from a purchase in Rakuten France',
    'tv.image.alt':
        'A young couple lays in a couch and enjoys watching a film on Rakuten TV while eating pop-corn',
    'rakuten.image.alt': 'A couple celebrates the benefits of Rakuten from home',
    'pointsTerms.description.1':
        'Please read the following carefully. The terms below explain the conditions applied for any Rakuten Point® (hereinafter referred to as a “Point” and in plural as “Points” or “Rakuten Points”), part of the customer loyalty scheme administered by Rakuten Europe. You expressly acknowledge and agree that you understand these Terms of Use before using Points.',
    'pointsTerms.effective.date': 'Effective date: January 1st, 2023',
    'pointsTerms.heading.1': 'Who is providing Rakuten Points',
    'pointsTerms.heading.1.description.1':
        'These Terms of Use are issued by Rakuten Europe S.à r.l. ("Rakuten"), registered under number B136664 at the Luxembourg Trade and Companies Register, with the VAT number LU22375408. You can contact Rakuten at: Address: 2 Rue du Fossé, Luxembourg, L-1536, LUXEMBOURG. ',
    'pointsTerms.heading.2': 'Terms and conditions',
    'pointsTerms.heading.2.description.1':
        'Points are available for Rakuten Group customers (“Users”) using any service operated by the Rakuten Group in Europe allowing the collection or use of Points in Europe, or any third-party site in Europe allowing the collection of Points, that you may be notified about from time to time, (together the “Services”).',
    'pointsTerms.heading.2.description.10':
        'Points will expire one (1) year from the date they were issued to the User. For certain campaigns, Points which expire less than one (1) year from the date they were issued may be provided. The special rules regarding such Points will be presented together with the conditions of the campaign on the relevant Service. In any case, Points will expire if the User closes his/her account with a Service for any reason.',
    'pointsTerms.heading.2.description.11':
        "In the event that Rakuten processes a User's personal data, it shall do so strictly in accordance with the Privacy Policy listed on the relevant Service. Rakuten shall use reasonable skill and due care in providing Points to you and strives to ensure that the information is accurate. Rakuten will use commercially reasonable efforts to correct errors and omissions as quickly as practicable after being notified. Beyond that, Rakuten does not provide any guarantee or warranty, express or implied, about Points.",
    'pointsTerms.heading.2.description.12':
        'Rakuten reserves the right to modify and/or terminate the Points Terms of Use, at its sole discretion.',
    'pointsTerms.heading.2.description.2':
        'Users will be able to earn Points on certain transactions conducted through the Services, such as purchases or other forms of customer engagement, and any other transactions as may be determined by each of the Services. The number of Points a User will earn will be specified in more detail in the relevant terms and conditions on each of the Services.',
    'pointsTerms.heading.2.description.3': 'If a User (where applicable):',
    'pointsTerms.heading.2.description.3.listItem.1': 'cancels his/her purchase; or',
    'pointsTerms.heading.2.description.3.listItem.2': 'returns his/her purchase,',
    'pointsTerms.heading.2.description.4':
        'any Points granted which are associated with that purchase will also be cancelled.',
    'pointsTerms.heading.2.description.5':
        'Users may be able to redeem Points either (i) against transactions made on any of the Services which offer the redemption of Points against transactions; or (ii) by exchanging for vouchers or gift cards, subject to applicable terms and conditions.',
    'pointsTerms.heading.2.description.6':
        'Should You decide to redeem Points against a purchase on one of the Services, Rakuten will deduct from your Point balance any amount which you decide to redeem against a purchase.',
    'pointsTerms.heading.2.description.7':
        'If you redeem Points against a purchase and later cancel or return the purchase, the redeemed Points will be added back to your Point balance within 30 days; however, if you are not permitted to cancel or redeem your purchase then your Points will be lost.',
    'pointsTerms.heading.2.description.8':
        'The rules governing the usage of, or the redemption of Points against purchases or transactions made on any of the Services, will be specified in more detail in the terms and conditions on each of the Services.',
    'pointsTerms.heading.2.description.9':
        'Subject to the minimum redemption amount, and where made available by the Services, Points may also be exchanged to other Rakuten Group services vouchers, such as for Rakuten TV, Rakuten Kobo or to Viber Out credit through the Rakuten cashback sites in UK, Spain and Germany. Points have no monetary value and cannot be assigned, transferred or redeemed in exchange for cash.',
    'pointsTerms.heading.3': 'Governing law and dispute settlement',
    'pointsTerms.heading.3.description.1':
        'Any dispute or claim arising out of or in connection with your use of Points shall be governed by and construed in accordance with the laws of the Grand-Duchy of Luxembourg, save and unless your local mandatory consumer law provides you with different rights.',
    'pointsTerms.heading.3.description.2':
        'Any dispute between us is subject to the non-exclusive jurisdiction of the courts of Luxembourg.',
    'pointsTerms.heading.4': 'Contact information',
    'pointsTerms.heading.4.description.1':
        'If you have any issues or queries regarding Points, please contact the relevant Service in the first instance. ',
    'pointsTerms.policy': 'Points Terms of Use',
    'pointsTerms.title': 'Rakuten Point - Terms of Use',
    'revoke.session.button.text': 'Sign out of all my devices',
    'revoke.session.success.text': 'Signed out of all devices',
    'revoke.session.error.text': 'You could not be signed out. Please reload and try again.',
    'notification.revoke.session.success': 'You have been signed out of all devices.',
    'notification.revoke.session.success.password.update.success':
        'Your password was successfully updated. You have been signed out of all devices.',
    'notification.revoke.session.success.email.update.success':
        'Your email was successfully updated. You have been signed out of all devices.',
    'notification.revoke.session.success.username.update.success':
        'Your username was successfully updated. You have been signed out of all devices.',
    'social.accounts.title': 'Linked social accounts (for login only)',
    'social.provider.google.linked': 'Google is linked',
    'social.provider.facebook.linked': 'Facebook is linked',
    'social.provider.apple.linked': 'Apple is linked',
    'social.accounts.unlink': 'Unlink',
    'social.unlink.confirmation.title': 'Unlink {provider} account',
    'social.unlink.confirmation.description1':
        'Please confirm that you want to unlink your {provider} account from {serviceName}. This will not delete or deactivate your Rakuten account.',
    'social.unlink.confirmation.description2': 'You can link your social account again at login.',
    'social.unlink.confirm.button': 'Unlink',
    'social.unlink.notice':
        "To unlink your social account, you'll need to re-authenticate using the {reAuthLink}. If you have trouble signing in, please use the account recovery option.",
    'social.unlink.notice.link': 'sign in page',
    'notifications.social.unlink.success': 'Your {provider} account was successfully unlinked.',
    'notifications.social.unlink.failure':
        'There was a problem submitting your request, please try again later.',
    'linked.accounts.page.title': 'Social Account Linkage Management',
    'linked.accounts.title': 'Social Account Linkage Management - Rakuten Account Management',
    'linked.accounts.subtitle': 'Manage your Rakuten services',
    'linked.accounts.info': 'Social account linkage is only available for Rakuten Travel.',
    'provider.name.google': 'Google',
    'provider.name.facebook': 'Facebook',
    'provider.name.apple': 'Apple',
    'service.name.rakuten.travel.global': 'Rakuten Travel Global',
    'service.name.rakuten.travel.taiwan': 'Rakuten Travel Taiwan',
    'service.name.rakuten.travel.korea': 'Rakuten Travel Korea',
    'unlink.modal.title': 'Unlink {providerName} account',
    'payment.card.add.consent':
        'I consent to the storage of my card information and the sharing of this information with {serviceName}, in accordance with the {privacyPolicyLink}.',
    'payment.card.add.consent.policy.link': 'Rakuten ID Privacy Policy',
};
